"use strict";

var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyValueStorage = void 0;
var tslib_1 = require("tslib");
var safe_json_utils_1 = require("safe-json-utils");
var localStorage_1 = tslib_1.__importDefault(require("./lib/localStorage"));
var shared_1 = require("../shared");
var KeyValueStorage = /*#__PURE__*/function () {
  function KeyValueStorage() {
    _classCallCheck(this, KeyValueStorage);
    this.localStorage = localStorage_1.default;
  }
  _createClass(KeyValueStorage, [{
    key: "getKeys",
    value: function getKeys() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Object.keys(this.localStorage));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getEntries",
    value: function getEntries() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object.entries(this.localStorage).map(shared_1.parseEntry));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var item;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              item = this.localStorage.getItem(key);
              if (!(item === null)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", undefined);
            case 3:
              return _context3.abrupt("return", safe_json_utils_1.safeJsonParse(item));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.localStorage.setItem(key, safe_json_utils_1.safeJsonStringify(value));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.localStorage.removeItem(key);
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }]);
  return KeyValueStorage;
}();
exports.KeyValueStorage = KeyValueStorage;
exports.default = KeyValueStorage;